import React from "react";
import { FileText, ShieldCheck, Lock, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DocumentationSamples() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const samples = [{
    title: "Progress Report",
    description: "Comprehensive functional capacity reporting designed for NDIS plan reviews. Features clear goal tracking and outcome measurements.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556888/img/progress_report_blurred.png",
    icon: <FileText className="size-5" />
  }, {
    title: "Service Agreement",
    description: "Clear, compliant terms of service outlining supports, cancellation policies, and billing schedules. Fully audit-ready structure.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556888/img/service_agreement_blurred.png",
    icon: <ShieldCheck className="size-5" />
  }, {
    title: "Incident Report",
    description: "Standardized critical incident documentation ensuring immediate compliance and proper stakeholder notification protocols.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556888/img/incident_report_blurred.png",
    icon: <Lock className="size-5" />
  }];
  return null;
}